<app-header></app-header>

<br />

<main class="main-content">
  <div class="crm mb-25">
    <div class="container-fluid">
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-xxl-12 mb-25">
              <div class="breadcrumb-main">
                <h4 class="text-capitalize breadcrumb-title">
                  <!-- Emails monitoring -->
                  {{ "email_monitoring.title" | translate }}
                </h4>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div
                    class="ap-po-details ap-po-details--luodcy overview-card-shape radius-xl d-flex justify-content-between"
                  >
                    <div
                      class="ap-po-details-content d-flex flex-wrap justify-content-between w-100"
                    >
                      <div class="ap-po-details__titlebar">
                        <p>
                          <!-- Emails Available -->
                          {{
                            "email_monitoring.stats.emails_available"
                              | translate
                          }}
                        </p>
                        <h1>{{ available_emails }}</h1>
                        <br />
                      </div>
                      <div class="ap-po-details__icon-area color-primary">
                        <i class="uil uil-arrow-growth"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="ap-po-details ap-po-details--luodcy overview-card-shape radius-xl d-flex justify-content-between"
                  >
                    <div
                      class="ap-po-details-content d-flex flex-wrap justify-content-between w-100"
                    >
                      <div class="ap-po-details__titlebar">
                        <p>
                          <!-- Emails used -->
                          {{ "email_monitoring.stats.emails_used" | translate }}
                        </p>
                        <h1>{{ used_emails }}</h1>
                        <br />
                      </div>
                      <div class="ap-po-details__icon-area color-secondary">
                        <i class="uil uil-users-alt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <br />
              </div>

              <div class="col-md-12">
                <div class="card">
                  <div class="card-body p-0">
                    <div class="table4 p-25 mb-30">
                      <div class="table-responsive">
                        <div
                          class="card-header d-flex justify-content-between align-items-center py-10 px-sm-25 px-3"
                        >
                          <h6 class="fw-500">
                            <!-- Emails -->
                            {{ "email_monitoring.table.emails" | translate }}
                          </h6>
                          <div class="ms-auto">
                            <a
                              href="javascript:void(0)"
                              class="btn px-15 btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#new-member2"
                              (click)="handleOpenModal()"
                            >
                              <i class="las la-plus fs-16"></i>
                              <!-- Add -->
                              {{ "email_monitoring.table.add" | translate }}
                            </a>
                          </div>
                          <br />
                        </div>
                        <br />

                        <table class="table mb-0">
                          <thead>
                            <tr class="userDatatable-header">
                              <th>
                                <span class="userDatatable-title">
                                  <!-- Email -->
                                  {{
                                    "email_monitoring.table.email" | translate
                                  }}
                                </span>
                              </th>
                              <th>
                                <span class="userDatatable-title">
                                  <!-- Type -->
                                  {{
                                    "email_monitoring.table.type" | translate
                                  }}
                                </span>
                              </th>
                              <th class="text-center">
                                <span class="userDatatable-title">
                                  <!-- Actions -->
                                  {{
                                    "email_monitoring.table.actions" | translate
                                  }}
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let email of emails">
                              <td>
                                <div class="userDatatable-content">
                                  {{ email.value }}
                                </div>
                              </td>
                              <td>
                                <div class="userDatatable-content">
                                  {{ getTranslation(email.type) | translate }}
                                </div>
                              </td>
                              <td class="text-center">
                                <a
                                  href="javascript:void(0)"
                                  class="edit"
                                  (click)="openDeletionModal(email)"
                                >
                                  <i
                                    class="fa fa-trash"
                                    style="color: gray"
                                  ></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <br />
              </div>

              <div class="col-md-12">
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<div
  class="modal fade new-member new-member__2"
  id="new-member2"
  tabindex="-1"
  aria-labelledby="staticBackdropLabel"
  aria-modal="true"
  role="dialog"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content radius-xl">
      <div class="modal-header">
        <h6 class="modal-title fw-500" id="staticBackdropLabel">
          <!-- Add email -->
          {{ "email_monitoring.modal_add.title" | translate }}
        </h6>
        <button
          type="button"
          class="close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="svg replaced-svg"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="new-member-modal">
          <form
            *ngIf="
              !isInviteEmailSubmited &&
              !isPersonalEmailSubmited &&
              hasAvailableEmails
            "
            #emailForm="ngForm"
          >
            <div class="form-group mb-20">
              <input
                type="email"
                class="form-control"
                [placeholder]="
                  'email_monitoring.modal_add.placeholder_email' | translate
                "
                [(ngModel)]="email"
                (input)="onEmailChange($event)"
                (keydown)="onEmailChange($event)"
                (paste)="onEmailChange($event)"
                name="email"
                email
                required
                #emailInput="ngModel"
              />
              <p
                *ngIf="emailInput.invalid && emailInput.touched"
                style="color: red"
              >
                <!-- Please enter a valid email address. -->
                {{ "email_monitoring.modal_add.invalid_email" | translate }}
              </p>
              <p *ngIf="is_already_used_email" style="color: red">
                <!-- {{ error_message }} -->
                {{ "email_monitoring.already_used_error" | translate }}
              </p>
            </div>
            <div>
              <div class="checkbox-theme-default custom-checkbox">
                <input
                  class="checkbox"
                  type="checkbox"
                  id="check-1"
                  [checked]="isPersonalEmailChecked"
                  (change)="onCheckboxChange('personal')"
                  [disabled]="!isInviteEmailVisible"
                />
                <label for="check-1">
                  <span class="checkbox-text">
                    <!-- It is my email -->
                    {{
                      "email_monitoring.modal_add.checkbox_personal" | translate
                    }}
                  </span>
                </label>
              </div>
              <div
                *ngIf="isInviteEmailVisible"
                class="checkbox-theme-default custom-checkbox"
              >
                <input
                  class="checkbox"
                  type="checkbox"
                  id="check-2"
                  [checked]="isInviteEmailChecked"
                  (change)="onCheckboxChange('invite')"
                />
                <label for="check-2">
                  <span class="checkbox-text">
                    <!-- Invite another person -->
                    {{
                      "email_monitoring.modal_add.checkbox_invite" | translate
                    }}
                  </span>
                </label>
              </div>
            </div>
            <div class="button-group d-flex pt-25">
              <button
                class="btn btn-primary btn-default btn-squared text-capitalize"
                [disabled]="emailForm.invalid"
                (click)="onEmailSubmit()"
              >
                <!-- Add -->
                {{ "email_monitoring.modal_add.button_add" | translate }}
              </button>
              <button
                type="button"
                class="btn btn-light btn-default btn-squared fw-400 text-capitalize b-light color-light"
                data-bs-dismiss="modal"
              >
                <!-- cancel -->
                {{ "email_monitoring.modal_add.button_cancel" | translate }}
              </button>
            </div>
          </form>

          <div
            *ngIf="isInviteEmailSubmited"
            class="card card-default card-md mb-4"
          >
            <div class="card-body">
              <div class="dm-notice__content">
                <div class="dm-notice__top text-center">
                  <div class="dm-notice__icon bg-success">
                    <i class="fas fa-check color-white"></i>
                  </div>
                  <div class="dm-notice__text">
                    <h4>
                      <!-- Successfully! -->
                      {{ "email_monitoring.success_invite.title" | translate }}
                    </h4>
                    <p>
                      <!-- Thank you so much for inviting another person! We've sent
                      an email with the invitation link. Once your invitee
                      registers an account and signs the authorization form,
                      they'll be able to enjoy our service free of charge until
                      the end of your subscription. -->
                      {{
                        "email_monitoring.success_invite.message" | translate
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="isPersonalEmailSubmited"
            class="card card-default card-md mb-4"
          >
            <div class="card-body">
              <div class="dm-notice__content">
                <div class="dm-notice__top text-center">
                  <div class="dm-notice__icon bg-success">
                    <i class="fas fa-check color-white"></i>
                  </div>
                  <div class="dm-notice__text">
                    <h4>
                      <!-- Successfully! -->
                      {{
                        "email_monitoring.success_personal.title" | translate
                      }}
                    </h4>
                    <p>
                      <!-- Thank you very much for providing additional information
                      for monitoring! We'll redirect you to the authorization
                      form so that we can contact data brokers with additional
                      details on your behalf! -->
                      {{
                        "email_monitoring.success_personal.message" | translate
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="!hasAvailableEmails"
            class="card card-default card-md mb-4"
          >
            <div class="card-body">
              <div class="dm-notice__content">
                <div class="dm-notice__top text-center">
                  <div class="dm-notice__icon bg-danger">
                    <i class="fas fa-exclamation-triangle color-white"></i>
                  </div>
                  <div class="dm-notice__text">
                    <p>
                      <!-- You don't have any available emails ! -->
                      {{
                        "email_monitoring.no_emails_left.message" | translate
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-info-confirmed modal fade"
  [ngClass]="{ 'show d-block': isDeletionModalOpen }"
  [ngStyle]="{ 'background-color': 'rgba(0, 0, 0, 0.4)' }"
  [attr.aria-hidden]="isDeletionModalOpen ? 'false' : 'true'"
  id="modal-info-confirmed"
  tabindex="-1"
  role="dialog"
  (click)="closeDeletionModal($event)"
>
  <div
    class="modal-dialog modal-dialog-centered modal-sm modal-info"
    role="document"
  >
    <div class="modal-content">
      <span class="del-modal-close" data-action="keep">x</span>
      <div class="modal-body">
        <div class="modal-info-body d-flex">
          <div class="modal-info-text">
            <h6 class="text-center">
              <!-- Are you sure you want to remove this email({{
                deletion_email?.value
              }}) from monitoring? -->
              {{
                "email_monitoring.deletion.confirm_title"
                  | translate : { email: deletion_email?.value }
              }}
            </h6>
          </div>
        </div>
      </div>
      <div
        *ngIf="!deletion_success_message && !deletion_error_message"
        class="modal-footer"
      >
        <button
          type="button"
          class="btn btn-light btn-outlined btn-sm"
          data-bs-dismiss="modal"
          data-action="keep"
        >
          <!-- Cancel -->
          {{ "email_monitoring.deletion.cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-info btn-sm"
          data-bs-dismiss="modal"
          data-action="confirm"
          (click)="handle_deletion_auth_form()"
        >
          <!-- Confirm removal -->
          {{ "email_monitoring.deletion.confirm" | translate }}
        </button>
      </div>
      <div *ngIf="deletion_error_message" class="alert alert-danger">
        {{ deletion_error_message }}
      </div>
      <div *ngIf="deletion_success_message" class="alert alert-success">
        {{ deletion_success_message }}
      </div>
    </div>
  </div>
</div>
